import { storage } from '@esri/telemetry';
const COGNITO_KEY = 'TELEMETRY_COGNITO_CREDENTIALS';
export function getCredentials(IdentityPoolId, options = {}) {
    const fipsSubdomainSuffix = options.fips === true ? '-fips' : '';
    const COGNITO_URL = `https://cognito-identity${fipsSubdomainSuffix}.us-east-1.amazonaws.com/`;
    let cached = storage.get(COGNITO_KEY);
    if (cached && Date.now() / 1000 < cached.Expiration)
        return Promise.resolve(cached);
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/x-amz-json-1.1',
            'X-Amz-Target': 'AWSCognitoIdentityService.GetId',
        },
        body: JSON.stringify({ IdentityPoolId }),
    };
    return fetch(COGNITO_URL, fetchOptions)
        .then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json();
    })
        .then((response) => {
        const { IdentityId } = response;
        const options = {
            method: 'POST',
            headers: {
                'Content-type': 'application/x-amz-json-1.1',
                'X-Amz-Target': 'AWSCognitoIdentityService.GetCredentialsForIdentity',
            },
            body: JSON.stringify({ IdentityId }),
        };
        return fetch(COGNITO_URL, options);
    })
        .then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json();
    })
        .then(({ Credentials }) => {
        storage.set(COGNITO_KEY, Credentials);
        return Credentials;
    });
}
//# sourceMappingURL=auth.js.map